import { render, staticRenderFns } from "./asignarEnlace.vue?vue&type=template&id=0722c574&"
import script from "./asignarEnlace.vue?vue&type=script&lang=js&"
export * from "./asignarEnlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports